"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "corte-palasio": {
    "1b963914": [{
      "hkey": "9107ed8b",
      "slug": "corte-palasio",
      "name": "Corte Palasio",
      "primary": true,
      "skipSearch": false
    }],
    "bocchirale": [{
      "hkey": "9107ed8b",
      "slug": "corte-palasio",
      "name": "Corte Palasio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "aa8490fa": [{
      "hkey": "9107ed8b",
      "slug": "corte-palasio",
      "name": "Corte Palasio",
      "primary": true,
      "skipSearch": false
    }],
    "casellario": [{
      "hkey": "9107ed8b",
      "slug": "corte-palasio",
      "name": "Corte Palasio",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "bd4d537f": [{
      "hkey": "dcd27614",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "palasio": [{
      "hkey": "dcd27614",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "50a58750": [{
      "hkey": "dcd27614",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "terraverde": [{
      "hkey": "dcd27614",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "corte-palasio"
    }]
  }
};
exports["default"] = _default;